import React from 'react';

import {Trans} from 'react-i18next';

import './styles.scss';

export interface IAlumni {
    name: string;
    role: string;
    quote: string;
    image: string;
}

interface IAlumniSectionProps {
    alumniList: IAlumni[];
}

export const AlumniSection = ({alumniList}: IAlumniSectionProps) => {
    return (
        <section id="alumni" className="alumni-section">
            <div className="alumni-section__container container text-center">
                <h2 className="alumni-section__title"><Trans>Our Alumni</Trans></h2>
                <p className="alumni-section__subtitle">
                    <Trans>Where are they now? See how our past students are making an impact.</Trans>
                </p>
                <div className="row">
                    {alumniList.map((alum, index) => (
                        <div className="col-md-4 mb-4" key={index}>
                            <div className="alumni-section__card">
                                <img
                                    src={alum.image}
                                    alt={alum.name}
                                    className="alumni-section__image"
                                />
                                <div className="alumni-section__content">
                                    <h5 className="alumni-section__name">{alum.name}</h5>
                                    <p className="alumni-section__role">{alum.role}</p>
                                    <p className="alumni-section__quote">“{alum.quote}”</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};